import { render } from "./ViewNoticia.vue?vue&type=template&id=17616a9f"
import script from "./ViewNoticia.vue?vue&type=script&lang=js"
export * from "./ViewNoticia.vue?vue&type=script&lang=js"

import "./ViewNoticia.vue?vue&type=style&index=0&id=17616a9f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__